import $http from '../../shared/http';

/**
 * This is a submodule of the organisations module.
 * Reference it from components with "organisations/organisation_preferences"
 */
export const organisation_preferences = {
  namespaced: true,
  state: () => {
    return {
      preferences: {},
      preferencesFormData: null,
      currenciesForSelect: null,
      timezonesForSelect: null,
    };
  },
  getters: {
    getMaxNumberOfMinistriesPerMember: (state) => state.preferences?.max_ministries_per_member ?? 2,
    getPreferredCurrency: (state) => state.preferences?.currency ?? null,
    getPreferencesFormData: (state) => state.preferencesFormData,
    getCurrenciesForSelect: (state) => state.currenciesForSelect,
    GET_TIMEZONES_FOR_SELECT: (state) => state.timezonesForSelect,
    preferredChurchLanguage: (state) => {
      return state.preferences?.language ?? null;
    },
    organisationPreferences: (state) => state.preferences,
    GET_ALL_ORGANISATION_PREFERENCES: (state) => state.preferences,
    GET_CHURCH_UTC_OFFSET: (state) => {
      /**
       * @constant offset
       * @type {string | null}
       */
      const offset = state.preferences?.timezone?.utcOffsetStr ?? null;
      if (offset) {
        const sign = offset.charAt(0);
        return 'UTC' + sign + Number(offset.split(':')[0].slice(1));
      } else {
        return 'UTC';
      }
    },
    GET_CHURCH_TIMEZONE: (state) => state.preferences?.timezone ?? null,
    IS_CHURCH_TIMEZONE_SET: (state) => {
      const timezonePreference = state.preferences.timezone ?? null;
      return !!timezonePreference;
    },
  },
  mutations: {
    setPreferences: (state, payload) => (state.preferences = payload),
    setPreferencesFormData(state, form) {
      state.preferencesFormData = form;
    },
    setCurrenciesForSelect(state, payload) {
      state.currenciesForSelect = payload;
    },
    setTimezonesForSelect: (state, payload) => (state.timezonesForSelect = payload),
    setOrganisationPreferences: (state, payload) => (state.preferences = payload),
  },
  actions: {
    async loadCurrenciesForSelect({ commit }) {
      return $http('v2')
        .get('/currencies')
        .then((response) => {
          commit('setCurrenciesForSelect', response.data.data);
          return response;
        });
    },

    // This is not church specific
    async LOAD_TIMEZONES_FOR_SELECT({ commit }) {
      return $http('v2')
        .get('timezones')
        .then((response) => {
          commit('setTimezonesForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_ALL_ORGANISATION_PREFERENCES({ commit }, { churchId }) {
      if (!churchId) {
        throw new Error('Church ID not provided');
      }

      return $http('v2')
        .get(`organisations/${churchId}/preferences`, { canBeImpersonated: true })
        .then((response) => {
          commit('setOrganisationPreferences', response.data.data);
          return response;
        });
    },

    async SAVE_ORGANISATION_PREFERENCES_ACTION({ dispatch }, { id, form }) {
      return $http('v2')
        .post(`organisations/${id}/preferences`, form, {
          notifiable: true,
        })
        .then(async (response) => {
          dispatch('LOAD_ALL_ORGANISATION_PREFERENCES', { churchId: id });
          return response;
        });
    },
  },
};
